import { useRef, useEffect, useState } from "react"; 

import { getLabel } from "../../tools/Dictionary";


import "./FileController.css";

import { MdDownload } from "react-icons/md";

const FileController = (props) => {

  //Props
  //const IsDesktop = props.isDesktop;
  //const Access = props.Access;
  const FileType = props.FileType;
  const PreviewUrl = props.PreviewUrl;
  const OnFileChange = props.OnFileChange;
  const FileLocation = props.FileLocation;
  const OnClick = props.OnClick;
  const FileName = props.FileName;
  const FileExtention = props.FileExtention;



  //State
  const [selected, setSelected] = useState(undefined);
  const [previewUrl, setPreviewUrl] = useState(PreviewUrl);
  const [fileType, setFileType] = useState(FileType);

  //Ref
  const videoRef = useRef(null);

  //Effect
  useEffect(() => {

    setPreviewUrl(PreviewUrl);
    setFileType(FileType);

  }, [PreviewUrl, FileType]);

  const onFileChange = (e) => {


    const currentFile = e.target.files[0];

    if (!currentFile) return;

    OnFileChange(currentFile);
    setSelected(currentFile);

    if (currentFile)
    {

      // Check the file type by examining the MIME type or file extension
      if (currentFile.type.startsWith('image/'))
      {
        setFileType('image');
      } else if (currentFile.type.startsWith('video/'))
      {
        setFileType('video');
        
        if (videoRef.current){

          videoRef.current.src = URL.createObjectURL(currentFile);
          videoRef.current.load(); // Load the new video source          

        }

      } else
      {
        setFileType('unknown');
      }

      const reader = new FileReader();

      reader.onloadend = () =>
      {
        // When the reader finishes loading the file, set the preview URL
        setPreviewUrl(reader.result);
      };

      reader.readAsDataURL(currentFile); // Read the file as a data URL
    } else
    {
      setPreviewUrl(''); // No file selected, clear the preview
    }


  };



  return (
    <div className="filecontroller_cont">
      {((previewUrl && fileType == "image") || (previewUrl && fileType == "video" && !selected)) &&
        <img
          src={previewUrl}
          alt="Preview"
          className="filecontroller_preview"
        />
      }
      {previewUrl && fileType == "video" && selected && (
        <video
          controls
          width="200"
          ref={videoRef}
        >
          <source
            src={URL.createObjectURL(selected)}
            type={selected.type}
          />
          Your browser does not support the video tag.
        </video>
      )}
      {selected && 
        <div className="filecontroller_name">
          {selected.name}
        </div>
      } 
      {!selected && FileLocation && 
        <div className="filecontroller_name">
          <div className="filecontroller_input" style={{ width: "50px", marginLeft: "0px" }} onClick={OnClick} title={getLabel("FileController", "Download")}>
            <MdDownload />
          </div>
          {FileName ? FileName + "." + FileExtention : FileLocation}

        </div>
      }
      <label className="filecontroller_input">
        {getLabel("FileController", "Browse")}
        <input type="file" name="media" accept="image/*,video/*,application/pdf" onChange={onFileChange} />
      </label>

    </div>
  )

};

export default FileController